import {connect} from 'react-redux';

import {getTimeFormat} from '../../../../libs/shared/core/src/store/data/preferences/commonPreferencesSelectors';
import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {ArbitraryCalendarEventViewerContent} from './arbitraryCalendarEventViewerContent';

/*
 * Props.
 */

interface ArbitraryCalendarEventViewerContentContainerProps {}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ArbitraryCalendarEventViewerContentContainerProps>()(() => ({
  timeFormat: getTimeFormat,
}));

export const ArbitraryCalendarEventViewerContentContainer = connect(mapStateToProps)(
  ArbitraryCalendarEventViewerContent,
);
